import { ReactComponent as FrozenIcon } from '../../../icons/frozen.svg';

import './frozen-disclaimer.scss';

export const FrozenDisclaimer = () => (
  <div className="frozen-disclaimer">
    <FrozenIcon width={20} height={20} />
    <span>
      This plan is delivered as a single frozen batch. Once it arrives, it is your
      responsibility to keep it frozen until you're ready to prepare each meal.
    </span>
  </div>
);
